import React from "react";
import { Tabs } from "antd";
import TrialClassRegistration from "./TrialClassRegistration/TrialClassRegistration";
import Classes from "./Class/Classes";

const TrialClass = () => {
  const { TabPane } = Tabs;

  return (
    <div>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Classes" key="1">
          <Classes />
        </TabPane>
        <TabPane tab="Sign-ups" key="2">
          <TrialClassRegistration />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default TrialClass;
